import { AppointmentType } from '@citruscamps/citrus-client'
import { DateTime } from 'luxon'
import React from 'react'
import { getDaysFromMilliseconds } from '../../../../../utils/miliseconds-conversion'

interface IProps {
  appointmentType: AppointmentType
}

export const AppointmentSchedulingText = ({ appointmentType }: IProps) => {
  if (
    appointmentType.period_type === 'fixed' &&
    appointmentType.starts_at &&
    appointmentType.ends_at
  ) {
    const zone = appointmentType.timezone
    const start_at = DateTime.fromJSDate(new Date(appointmentType.starts_at), {
      zone,
    })
    const ends_at: DateTime = DateTime.fromJSDate(new Date(appointmentType.ends_at), {
      zone,
    })
    return (
      <span>
        {start_at.hasSame(ends_at, 'day')
          ? `${start_at.toFormat(`MMMM d yyyy, t`)} - ${ends_at.toFormat(`t ZZZZ`)}`
          : `${start_at.toFormat(`MMMM d yyyy, t`)} - ${ends_at.toFormat(`MMMM d yyyy, t ZZZZ`)}`}
      </span>
    )
  }
  if (appointmentType.period_type === 'moving') {
    return (
      <span>
        {`Scheduling ${getDaysFromMilliseconds(
          appointmentType.max_booking_time || 0,
        )} calendar days into the future`}
      </span>
    )
  }
  if (appointmentType.period_type === 'unlimited') {
    return <span>Scheduling indefinitely into the future</span>
  }
  return <span>Unknown schedule</span>
}
